/**
 * News category color mapping for badges and tabs.
 */
export const NEWS_CATEGORY_COLORS: Record<string, { badge: string; tabSelected: string; tabUnselected: string }> = {
  all: {
    badge: 'bg-slate-100 text-slate-800',
    tabSelected: 'bg-slate-700 text-white',
    tabUnselected: 'bg-slate-100 text-slate-700 hover:bg-slate-200',
  },
  equipment_materials: {
    badge: 'bg-blue-100 text-blue-800',
    tabSelected: 'bg-blue-600 text-white',
    tabUnselected: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
  },
  research_development: {
    badge: 'bg-emerald-100 text-emerald-800',
    tabSelected: 'bg-emerald-600 text-white',
    tabUnselected: 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100',
  },
  finance_economic: {
    badge: 'bg-amber-100 text-amber-800',
    tabSelected: 'bg-amber-600 text-white',
    tabUnselected: 'bg-amber-50 text-amber-700 hover:bg-amber-100',
  },
  weather: {
    badge: 'bg-sky-100 text-sky-800',
    tabSelected: 'bg-sky-600 text-white',
    tabUnselected: 'bg-sky-50 text-sky-700 hover:bg-sky-100',
  },
  others: {
    badge: 'bg-gray-100 text-gray-800',
    tabSelected: 'bg-gray-600 text-white',
    tabUnselected: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  },
};

export const getCategoryBadgeClass = (categoryId: string): string =>
  NEWS_CATEGORY_COLORS[categoryId]?.badge ?? NEWS_CATEGORY_COLORS.others.badge;

export const getCategoryTabClasses = (categoryId: string, isSelected: boolean): string => {
  const c = NEWS_CATEGORY_COLORS[categoryId] ?? NEWS_CATEGORY_COLORS.others;
  return isSelected ? c.tabSelected : c.tabUnselected;
};
